export const PUBLICATION_MODES = Object.freeze({
  MAINTENANCE: 'maintenance',
  SELECTIVE: 'selective',
  FULL: 'full',
});

export const PUBLICATION_MODE_ENV_NAME = 'VITE_PUBLICATION_MODE';

export const PUBLICATION_MODE_REASONS = Object.freeze({
  CONFIGURATION_MISSING: 'configuration_missing',
  CONFIGURATION_INVALID: 'configuration_invalid',
  CONFIGURED_MAINTENANCE: 'configured_maintenance',
  MAINTENANCE_STATE_UNAVAILABLE: 'maintenance_state_unavailable',
  MAINTENANCE_ACTIVE: 'maintenance_active',
  CONFIGURED_SELECTIVE: 'configured_selective',
  CONFIGURED_FULL: 'configured_full',
});

const VALID_PUBLICATION_MODES = new Set(Object.values(PUBLICATION_MODES));

const hasConfiguredValue = (value) =>
  value !== undefined && value !== null && String(value).trim().length > 0;

export const normalizePublicationMode = (value) => {
  if (!hasConfiguredValue(value)) {
    return null;
  }

  const normalized = String(value).trim().toLowerCase();
  return VALID_PUBLICATION_MODES.has(normalized) ? normalized : null;
};

export const resolveConfiguredPublicationMode = (value) =>
  normalizePublicationMode(value) || PUBLICATION_MODES.MAINTENANCE;

export const resolvePublicationState = ({
  configuredValue,
  maintenanceActive,
  maintenanceStateAvailable = true,
} = {}) => {
  const normalizedMode = normalizePublicationMode(configuredValue);

  if (!normalizedMode) {
    return {
      configuredMode: PUBLICATION_MODES.MAINTENANCE,
      effectiveMode: PUBLICATION_MODES.MAINTENANCE,
      reason: hasConfiguredValue(configuredValue)
        ? PUBLICATION_MODE_REASONS.CONFIGURATION_INVALID
        : PUBLICATION_MODE_REASONS.CONFIGURATION_MISSING,
      isFailClosed: true,
    };
  }

  if (normalizedMode === PUBLICATION_MODES.MAINTENANCE) {
    return {
      configuredMode: normalizedMode,
      effectiveMode: PUBLICATION_MODES.MAINTENANCE,
      reason: PUBLICATION_MODE_REASONS.CONFIGURED_MAINTENANCE,
      isFailClosed: false,
    };
  }

  if (maintenanceStateAvailable !== true || typeof maintenanceActive !== 'boolean') {
    return {
      configuredMode: normalizedMode,
      effectiveMode: PUBLICATION_MODES.MAINTENANCE,
      reason: PUBLICATION_MODE_REASONS.MAINTENANCE_STATE_UNAVAILABLE,
      isFailClosed: true,
    };
  }

  if (maintenanceActive) {
    return {
      configuredMode: normalizedMode,
      effectiveMode: PUBLICATION_MODES.MAINTENANCE,
      reason: PUBLICATION_MODE_REASONS.MAINTENANCE_ACTIVE,
      isFailClosed: false,
    };
  }

  return {
    configuredMode: normalizedMode,
    effectiveMode: normalizedMode,
    reason:
      normalizedMode === PUBLICATION_MODES.SELECTIVE
        ? PUBLICATION_MODE_REASONS.CONFIGURED_SELECTIVE
        : PUBLICATION_MODE_REASONS.CONFIGURED_FULL,
    isFailClosed: false,
  };
};

export const resolveEffectivePublicationMode = (options) =>
  resolvePublicationState(options).effectiveMode;
